export default __webpack_public_path__ + "static/media/unsere_haeuser_web-lg@1x.2137b548.webp";